(function () {
  'use strict';

  var MARKER_SELECTORS = '[data-lp-feature-bento], [data-lp-pdp-features-stack]';
  var ROOT_CLASS = 'lp-pdp-hide-floating-widgets';
  var SMILE_SELECTORS = '#smile-ui-lite-launcher-frame-container, #smile-ui-container, [id^="smile-ui-lite-launcher"]';
  var rafId = 0;
  var smileRafId = 0;
  var smileObserver = null;

  function getMarkers() {
    return Array.prototype.slice.call(document.querySelectorAll(MARKER_SELECTORS));
  }

  function getSmileLaunchers() {
    return Array.prototype.slice.call(document.querySelectorAll(SMILE_SELECTORS));
  }

  function markerInFeatureZone(marker) {
    var rect = marker.getBoundingClientRect();
    var headerOffset = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    ) || 72;
    var enterLine = headerOffset + 48;

    return rect.top < window.innerHeight * 0.88 && rect.bottom > enterLine;
  }

  function syncHiddenState() {
    rafId = 0;
    var markers = getMarkers();
    if (!markers.length) return;

    var hide = markers.some(markerInFeatureZone);
    document.documentElement.classList.toggle(ROOT_CLASS, hide);
    requestSmileOffsetSync();
  }

  function requestSync() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(syncHiddenState);
  }

  function getStickyBarOffsetBottom() {
    if (!document.documentElement.classList.contains('lp-pdp-sticky-bar-visible')) return '';
    if (document.documentElement.classList.contains(ROOT_CLASS)) return '';

    var barHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--lp-pdp-sticky-bar-height')
    ) || 0;
    if (barHeight <= 0) return '';

    return 'calc(' + barHeight + 'px + env(safe-area-inset-bottom, 0px) + 16px)';
  }

  function syncSmileLauncherOffset() {
    smileRafId = 0;
    if (!document.querySelector('[data-lp-pdp-sticky-bar]')) return;

    var bottom = getStickyBarOffsetBottom();
    getSmileLaunchers().forEach(function (el) {
      if (bottom) {
        el.style.setProperty('bottom', bottom, 'important');
      } else {
        el.style.removeProperty('bottom');
      }
    });
  }

  function requestSmileOffsetSync() {
    if (smileRafId) return;
    smileRafId = window.requestAnimationFrame(syncSmileLauncherOffset);
  }

  function watchSmileInjections() {
    if (smileObserver || !document.body) return;
    smileObserver = new MutationObserver(function () {
      if (getSmileLaunchers().length) requestSmileOffsetSync();
    });
    smileObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initFloatingWidgetToggle() {
    if (!getMarkers().length || document.documentElement.dataset.lpPdpFloatingWidgetsInit === 'true') {
      return;
    }
    document.documentElement.dataset.lpPdpFloatingWidgetsInit = 'true';

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    requestSync();
  }

  function initSmileLauncherOffset() {
    if (!document.querySelector('[data-lp-pdp-sticky-bar]')) return;
    if (document.documentElement.dataset.lpPdpSmileOffsetInit === 'true') return;
    document.documentElement.dataset.lpPdpSmileOffsetInit = 'true';

    watchSmileInjections();
    window.addEventListener('scroll', requestSmileOffsetSync, { passive: true });
    window.addEventListener('resize', requestSmileOffsetSync, { passive: true });
    window.addEventListener('lp-pdp-sticky-bar-change', requestSmileOffsetSync, { passive: true });
    requestSmileOffsetSync();
    window.setTimeout(requestSmileOffsetSync, 500);
    window.setTimeout(requestSmileOffsetSync, 2000);
  }

  function init() {
    initFloatingWidgetToggle();
    initSmileLauncherOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
